import { configEnv } from '@libraries/config';

const seoConfig = {
  title: 'Sistem Informasi Sekolah',
  description: 'Sistem Informasi Sekolah',
  openGraph: {
    type: 'website',
    locale: 'id_ID',
    url: configEnv.baseUrl,
    siteName: 'sissaas',
  },
  twitter: {
    handle: '@sissaas',
    site: '@sissaas',
    cardType: 'summary_large_image',
  },
};

export default seoConfig;
